// T.C. kimlik no alanı — website data.php storeTcknAlani + storeTcknScript karşılığı.
// Yazarken erken uyarmaz: 11 hane dolmadan yalnız rakam dışı karakteri söyler; blur'da
// ya da `zorla` (gönderim) ile tüm hatalar gösterilir.
import React, { useState } from "react";
import { tcknHata } from "../storeData";

export default function TcknField({ id, value, onChange, not = "", zorla = false }) {
  const [dokunuldu, setDokunuldu] = useState(false);
  const t = String(value || "").trim();
  const h = tcknHata(t);
  const goster = zorla || (dokunuldu && t !== "") || t.length === 11 || /[^0-9]/.test(t);
  const hataVar = goster && !!h;
  const msgClass = `st-field__msg${hataVar ? " is-hata" : !h ? " is-gecerli" : ""}`;
  return (
    <label className="st-field" htmlFor={id}>
      <span className="st-field__lbl">
        T.C. Kimlik No <em>*</em>
      </span>
      {/* maxlength YOK: boşluklu yapıştırma ("1000 0000 146") kesilmesin; boşluk temizlenir. */}
      <input
        className={`st-input${hataVar ? " is-hata" : ""}${!h ? " is-gecerli" : ""}`}
        id={id}
        type="text"
        inputMode="numeric"
        autoComplete="off"
        required
        placeholder="11 haneli kimlik numaranız"
        aria-describedby={`${id}-msg`}
        aria-invalid={hataVar ? "true" : "false"}
        value={value}
        onChange={(e) => onChange(e.target.value.replace(/\s+/g, ""))}
        onBlur={() => setDokunuldu(true)}
      />
      <span className={msgClass} id={`${id}-msg`} aria-live="polite">
        {hataVar ? h : !h ? "Geçerli T.C. kimlik numarası." : ""}
      </span>
      {not ? <span className="st-field__hint">{not}</span> : null}
    </label>
  );
}
